import axios from "utils/APIv2";

const saveAcumaticaSettings = async (data) => {
  const response = await axios.post('/acumatica-settings', data);
  return response.data;
};

const getAcumaticaSettings = async () => {
  const response = await axios.get('/acumatica-settings');
  return response.data;
};

const saveTokens = async (payload) => {
  return axios.post("acumatica-settings/save-tokens", payload);
};

const generateTokens = async (payload) => {
  return axios.post("acumatica-settings/generate-tokens", payload);
};

export default {
  saveAcumaticaSettings,
  getAcumaticaSettings,
  saveTokens,
  generateTokens,
};
